import { BoxShopItemCategory } from "@/modules/boxShop/gateway/boxShopApiDto"
import type { BoxShopSalesCouponDto } from "@/modules/boxShop/gateway/boxShopSalesApiDto"
import type { MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { OutOfBandTransactionStatus } from "@/modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"

export type BoxShopItemFormValues = {
  image: MediaItemFormType | null
  title: string
  brand: string | null
  description: string
  category: BoxShopItemCategory | null
  price: number
  stock: number | null
}

export const BoxShopSalesPayement = {
  DIRECT: "DIRECT",
  LINK: "LINK",
} as const
export type BoxShopSalesPayement = (typeof BoxShopSalesPayement)[keyof typeof BoxShopSalesPayement]

export type BoxShopSalesFormValues = {
  payment: BoxShopSalesPayement
  outOfBand: OutOfBandTransactionStatus | null
  items: {
    id: string
    quantity: number
  }[]
  coupon: BoxShopSalesCouponDto | null
  userId: string | null
}

export type BoxShopSendEmailFormValues = {
  userId: string | null
  email: string | null
}
